import { ContextConsumer } from '@lit/context'
import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import { cardPartRegistryContext } from './card-context.js'
import style from './parts.css'

/**
 * The main content region of a composed [Card](/components/card/). Applies the
 * card's body padding and grows to fill the available space between the
 * [Card Header](/components/card-header/) and [Card Footer](/components/card-footer/).
 *
 * Place it as a direct child of `nord-card`.
 *
 * @status draft
 * @category structure
 * @lightDom true
 *
 * @slot - The card body content.
 */
@customElement('nord-card-body')
export default class CardBody extends DraftComponentMixin(LitElement) {
  private registry = new ContextConsumer(this, {
    context: cardPartRegistryContext,
    subscribe: true,
    callback: registry => registry?.add(this),
  })

  connectedCallback() {
    super.connectedCallback()
    this.registry.value?.add(this)
    injectLegacyLightDomStyles(this, style, 'nord-card-parts')
  }

  disconnectedCallback() {
    this.registry.value?.remove(this)
    super.disconnectedCallback()
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-card-body': CardBody
  }
}
